export enum UserStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'Deleted',
  NeedPasswordChange = 'NEED_PASSWORD_CHANGE',
  UserPasswordChange = 'USER_PASSWORD_CHANGE',
  WaitingForActivation = 'WAITING_FOR_ACTIVATION',
  Inactive = 'INACTIVE',
  Deactivated = 'DEACTIVATED',
}

export enum UserStatusExisting {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  NeedPasswordChange = 'NEED_PASSWORD_CHANGE',
  UserPasswordChange = 'USER_PASSWORD_CHANGE',
  WaitingForActivation = 'WAITING_FOR_ACTIVATION',
  Inactive = 'INACTIVE',
  Deactivated = 'DEACTIVATED',
}

export const userStatusLabelMap = new Map<UserStatus, string>([
  [UserStatus.Active, 'status.active'],
  [UserStatus.Deactivated, 'status.deactivated'],
  [UserStatus.Archived, 'status.archived'],
  [UserStatus.NeedPasswordChange, 'status.needPasswordChange'],
  [UserStatus.UserPasswordChange, 'status.userPasswordChange'],
  [UserStatus.WaitingForActivation, 'status.waitingForActivation'],
  [UserStatus.Inactive, 'status.waitingForActivation'],
]);

const userDeletedStatuses = [UserStatus.Deleted, UserStatus.Archived];

export const isUserDeleted = (status: UserStatus) =>
  userDeletedStatuses.includes(status);
